module.exports = __webpack_public_path__ + "static/media/N50.cad89dae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N50.svg
// module id = 201
// module chunks = 0